<button *ngIf="farmAndFields && farmAndFields.length > 0" class="expandColapse" mat-mini-fab color="default"  cdkDrag (click)="toggleExpandCollapse()">
  <mat-icon class="material-symbols-outlined">
    {{ isExpanded ? 'collapse_all' : 'expand_all' }}
    </mat-icon>
</button>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding >
        <button mat-icon-button disabled *ngIf="!node.field.isNotVisible" ></button>
        <!-- <mat-radio-button [checked]="checkSelected(node)" > -->
          <a *ngIf="!node.field.isNotVisible" [ngClass]="'ta-farmfield-' + node.name.toLowerCase().replaceAll(' ','-')" (click)="showFieldSplits(node.field)" [class.disabled]="node.field.isDisabled"> {{node.name}}</a>
        <!-- </mat-radio-button> -->
   </mat-tree-node> 
  <!-- This is the tree node template for expandable nodes -->
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding  >
    <button mat-icon-button matTreeNodeToggle *ngIf="!node.field.isNotVisible" 
            [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <!-- <i [ngClass]="{ 'fa-solid fa-arrow-right': treeControl.isExpanded(node), 'fa-solid fa-arrow-up': !treeControl.isExpanded(node) }" ></i> -->
    <!-- <mat-radio-button [checked]="checkSelected(node)" > -->
      <a [class.disabled]="node.field.isDisabled" [ngClass]="'ta-farmfield-' + node.name.toLowerCase().replaceAll(' ','-')"  *ngIf="!node.field.isNotVisible" (click)="showFarmSplits(node.field)"> {{node.name}}</a>
    <!-- </mat-radio-button> -->
  </mat-tree-node>
</mat-tree>